<script setup>
import BoundedComponent from '@/components/BoundedComponent.vue';
import LogoJSON from '@/lotties/logo.json';
</script>

<template>
  <BoundedComponent is="footer">
    <div
      class="bg-brown rounded-t-6xl relative mt-40 lg:mt-30 pb-25 inner-block-px"
    >
      <div
        v-bounce-in
        class="w-34 h-34 bg-yellow rounded-full overflow-visible absolute top-0 pt-4 -translate-1/2 left-1/2 select-none"
      >
        <Vue3Lottie
          class="lottie-responsive"
          :animationData="LogoJSON"
          :width="106"
          :height="106"
          role="img"
          aria-label="lógó"
        />
      </div>
      <div
        class="flex flex-col items-center justify-center lg:justify-around pt-31 gap-11 lg:flex-row flex-wrap w-full"
      >
        <div class="text-white text-center mb-4 basis-full">
          <p class="max-w-[610px] mx-auto">
            Verkefnið er unnið af PIPAR\TBWA og Skot Productions fyrir Netvís -
            Netöryggismiðstöð Íslands, með styrk frá menningar- og
            viðskiptaráðuneytinu. Bernhard Kristinn tók myndirnar og Jóhannes
            Damian Patreksson, betur þekkur sem JóiPé, samdi tónlistina.
          </p>
        </div>
        <img
          loading="lazy"
          src="/images/pipar.png"
          alt="Pipar\TBWA"
          class="w-44"
          width="176"
          height="30"
        />
        <img
          loading="lazy"
          src="/images/scot.svg"
          alt="SCOT"
          class="w-44"
          width="176"
          height="24"
        />
        <a href="https://netvis.is/" target="_blank" rel="noopener noreferrer">
          <img
            loading="lazy"
            src="/images/netwis.svg"
            alt="netwis"
            class="w-30"
            width="120"
            height="28"
          />
        </a>

        <img
          loading="lazy"
          src="/images/islands.png"
          alt="stjórnarráð"
          class="w-80"
          width="320"
          height="54"
        />
      </div>
    </div>
  </BoundedComponent>
</template>
